export enum ServiceType {
    consultation = 'consultation',
    contact = 'contact',
    counseling = 'counseling',
    examination = 'examination',
    inquiry = 'inquiry',
    invitation = 'invitation',
    other = 'other',
    referral = 'referral',
    referralSmall = 'referralSmall',
}
